import {IconProps} from './types';

const Plus = ({fill = 'currentColor', className, width = 16, height = 16}: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 16 16"
        className={className}
    >
        <path
            fill={fill}
            d="M8 3.333a.667.667 0 0 1 .667.667v3.333H12a.667.667 0 1 1 0 1.334H8.667V12a.667.667 0 1 1-1.334 0V8.667H4a.667.667 0 0 1 0-1.334h3.333V4A.667.667 0 0 1 8 3.333z"
        />
    </svg>
);

export default Plus;
